function SectionHeading({ eyebrow, title, children }) {
  return (
    <div className="section-heading center reveal">
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="h2">{title}</h2>
      {children && <p className="sub">{children}</p>}
    </div>
  );
}

export default SectionHeading;
